module.exports = __webpack_public_path__ + "static/media/4.3ba6a87e.svg";